import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  initialMachineMaterialPageState,
  MachineMaterialItemData,
} from "../core/_model.machine";
import {
  DefaultListResponse,
  DefaultListStateType,
} from "../../../common/models/StoreDefaultModel";

export type ActionedMachineMaterial = {
  data: MachineMaterialItemData | null;
  action: ActionsKey;
};

type MachineMaterialDataType = {
  machineMaterialList: any;
  detail: MachineMaterialItemData | null;
  actioned: ActionedMachineMaterial | null;
  totalItems?: number;
  setDetail: (detail: MachineMaterialItemData | null) => void;
  setMachineMaterialList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedMachineMaterial | null) => void;
};

export const useMachineMaterialStore = create<MachineMaterialDataType>(
  (set) => ({
    machineMaterialList: [],
    detail: null,
    actioned: null,

    setDetail: (detail) => set((state) => ({ detail })),
    setMachineMaterialList: (saleData) =>
      set((state) => ({
        machineMaterialList: saleData?.member,
        totalItems: saleData?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
  })
);

export const useMachineMaterialListState = create<DefaultListStateType>(
  (set) => ({
    pageState: initialMachineMaterialPageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);
